import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  getRoleValue = '';
  userRoleData; 
  getProfileRoleData = new BehaviorSubject<any>([]);
  getProfileRoleData$ = this.getProfileRoleData.asObservable();
  flagUrl = new BehaviorSubject<any>([]);
  flagUrl$ = this.flagUrl.asObservable();
  getLandingPageData = new BehaviorSubject<any>({});
  getLandingPageData$ = this.getLandingPageData.asObservable();
  getApplicationPageData = new BehaviorSubject<any>({});
  getApplicationPageData$ = this.getApplicationPageData.asObservable();
  getAppMangerRoleData = new BehaviorSubject<any>([]);
  getAppMangerRoleData$ = this.getAppMangerRoleData.asObservable();
  getSubscriptionData = new BehaviorSubject<any>({});
  getSubscriptionData$ = this.getSubscriptionData.asObservable();
  signInPHusr = new BehaviorSubject<any>('');
  signInPHusr$ = this.signInPHusr.asObservable();
  mainMenuView = new BehaviorSubject(false);
  userDetail = null;
  mainMenuView$ = this.mainMenuView.asObservable();
  getRoleValueAccess = new Subject<any>();
  getRoleValueAccess$ = this.getRoleValueAccess.asObservable();
  loginView = new BehaviorSubject({ loginRedirection: "" });
  loginView$ = this.loginView.asObservable();
  private defaultExpandValue = new BehaviorSubject<boolean>(true);
  currentExpantValue = this.defaultExpandValue.asObservable();
  getUserRole = new BehaviorSubject<any>('');
  getUserRole$ = this.getUserRole.asObservable();
  getProfileData = new BehaviorSubject<any>({});
  getProfileData$ = this.getProfileData.asObservable();
  facilityAccount = new BehaviorSubject<any>({});
  facilityAccount$ = this.facilityAccount.asObservable();
  createdUserGroup = new BehaviorSubject<any>({});
  createdUserGroup$ = this.createdUserGroup.asObservable();
  getLanguageList = new BehaviorSubject<any>([]);
  getLanguageList$ = this.getLanguageList.asObservable();
  reloadPin = new BehaviorSubject<any>(true);
  reloadPin$ = this.reloadPin.asObservable();
  reloadProfile = new BehaviorSubject<any>(true);
  reloadProfile$ = this.reloadProfile.asObservable();
  private defaultRightNavValue = new BehaviorSubject<boolean>(false);
  currentRightNavValue = this.defaultRightNavValue.asObservable();

  private defaultDrawerValue = new BehaviorSubject("");
  currentDrawerValue = this.defaultDrawerValue.asObservable();

  private defaultActiveValue = new BehaviorSubject<boolean>(false);
  currentActiveValue = this.defaultActiveValue.asObservable();

  private defaultMainMenuValue = new BehaviorSubject({});
  currentMainMenuValue = this.defaultMainMenuValue.asObservable();

  private defaultFormValidtion = new BehaviorSubject({});
  currentFormValidtion = this.defaultFormValidtion.asObservable();
  // userDetails = new BehaviorSubject({});
  // userDetails$ = this.userDetails.asObservable();
  userDisplay = new BehaviorSubject("");
  userDisplay$ = this.userDisplay.asObservable();
  public isLoading = new BehaviorSubject(false);

  userRoleDetails: any = null;

  constructor() { }

  changeExpandValue(flag: boolean) {
    this.defaultExpandValue.next(flag);
  }
  changeDrawerValue(flag) {
    this.defaultDrawerValue.next(flag);
  }
  changeRightNavExp(flag: boolean) {
    this.defaultRightNavValue.next(flag);
  }
  changeActiveValue(flag: boolean) {
    this.defaultActiveValue.next(flag);
  }
  changeMainMenuValue(appdata: any) {
    this.defaultMainMenuValue.next(appdata);
  }

  changeFormValidtion(appdata: any) {
    this.defaultMainMenuValue.next(appdata);
  }

  timeCon24To12(input): string // 24 hrs to 12 hrs format
  {
    if (input) {
      let time = input.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [input];
      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      let fTime = time.join('');
      return fTime;
    }
  }
}